module.exports = __webpack_public_path__ + "img/winner.c58dbfea.png";